import axiosClient from './axiosClient';

export const pcBuilderService = {
    getComponents: () => axiosClient.get('/public/pc-builder/components'),

    getItemsForComponent: (componentCode, compatType = null, compatValue = null) => {
        const params = { componentCode };
        if (compatType && compatValue) {
            params.compatType = compatType;
            params.compatValue = compatValue;
        }
        return axiosClient.get('/public/pc-builder/items', { params });
    }
};